angular.module('impactx.opengovernmentdata').controller('TenderThresholdListCtrl', [TenderThresholdListController]);

function TenderThresholdListController() {
    var self = this;

    self.meta = {
        rowTemplate: 'modules/opengovernmentdata/templates/tenderthresholdlist.row.tmpl.html',
        isSelectAble: false,
        ctrl: self,
        endpoint: '/opengovernmentdata/tenderthreshold/list',
        id: "tenderthreshold",
        excelExport: true
    };

    self.getMeta = function () {
        return self.meta;
    };
}